"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _react = /*#__PURE__*/ _interop_require_default(require("react"));
var _core = require("@mantine/core");
var _hooks = require("@mantine/hooks");
var _clsx = /*#__PURE__*/ _interop_require_default(require("clsx"));
var _link = /*#__PURE__*/ _interop_require_default(require("next/link"));
var _editFormTimelinemodulecss = /*#__PURE__*/ _interop_require_default(require("../../../dist/assets/components/editFormTimeline.module.css"));
var _icons = require("../../assets/icons");
var _colourconstantspartner = /*#__PURE__*/ _interop_require_default(require("../../colour-constants-partner"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var EditFormTimeline = function(param) {
    var items = param.items, currentStep = param.currentStep;
    var _items_find;
    var isMobile = (0, _hooks.useMediaQuery)("(max-width: 768px)");
    var _React_useState = _react.default.useState(false), opened = _React_useState[0], setOpened = _React_useState[1];
    var renderItems = function() {
        return items.map(function(param) {
            var id = param.id, item = param.item;
            var _item_isAdviceRequired;
            return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Timeline.Item, {
                title: item.label,
                bullet: item.icon,
                className: _editFormTimelinemodulecss.default["state-" + item.state],
                classNames: {
                    itemBullet: _editFormTimelinemodulecss.default["bullet-" + item.state],
                    itemContent: _editFormTimelinemodulecss.default.itemContent
                },
                "data-current": id === currentStep,
                tabIndex: 0,
                "aria-current": id === currentStep ? "step" : undefined,
                component: _link.default,
                // @ts-expect-error
                href: item.href,
                onClick: function() {
                    return setOpened(false);
                },
                children: (item == null ? void 0 : (_item_isAdviceRequired = item.isAdviceRequired) == null ? void 0 : _item_isAdviceRequired[id]) && /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
                    className: _editFormTimelinemodulecss.default.iconContainer,
                    children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Tooltip, {
                        label: "" + item.label + " advice",
                        withArrow: true,
                        events: {
                            hover: true,
                            focus: false,
                            touch: false
                        },
                        position: "bottom",
                        zIndex: 405,
                        children: /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_icons.InfoIcon, {
                                color: _colourconstantspartner.default["accent-amber"],
                                className: _editFormTimelinemodulecss.default.infoIcon,
                                role: "img",
                                "aria-label": "" + item.label + " advice"
                            })
                        })
                    })
                })
            }, id);
        });
    };
    var renderTimeline = function() {
        return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Timeline, {
            classNames: {
                itemBullet: _editFormTimelinemodulecss.default.bullet,
                itemBody: _editFormTimelinemodulecss.default.itemBody,
                itemTitle: _editFormTimelinemodulecss.default.itemTitle,
                item: _editFormTimelinemodulecss.default.item,
                root: _editFormTimelinemodulecss.default.root
            },
            bulletSize: 24,
            children: renderItems()
        });
    };
    var currentItem = (_items_find = items.find(function(param) {
        var id = param.id;
        return id === currentStep;
    })) == null ? void 0 : _items_find.item;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_jsxruntime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0, _jsxruntime.jsxs)(_jsxruntime.Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Group, {
                    children: [
                        /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Burger, {
                            opened: opened,
                            size: "sm",
                            onClick: function() {
                                return setOpened(true);
                            },
                            "aria-label": "Show edit menu",
                            className: _editFormTimelinemodulecss.default["drawer-button"]
                        }),
                        currentItem && /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Group, {
                            gap: "sm",
                            className: _editFormTimelinemodulecss.default["mobile-current-step"],
                            children: [
                                /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.ThemeIcon, {
                                    radius: "xl",
                                    size: "sm",
                                    classNames: {
                                        root: (0, _clsx.default)(_editFormTimelinemodulecss.default["mobile-icon"], _editFormTimelinemodulecss.default["mobile-icon-" + currentItem.state])
                                    },
                                    children: currentItem.icon
                                }),
                                /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Text, {
                                    children: currentItem.label
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Drawer, {
                    classNames: {
                        inner: _editFormTimelinemodulecss.default.drawerInner,
                        overlay: _editFormTimelinemodulecss.default.drawerOverlay
                    },
                    opened: opened,
                    onClick: function() {
                        return setOpened(false);
                    },
                    onClose: function() {
                        return setOpened(false);
                    },
                    title: "Navigation",
                    padding: "xl",
                    size: "md",
                    closeButtonProps: {
                        "aria-label": "Close navigation"
                    },
                    children: renderTimeline()
                })
            ]
        }) : renderTimeline()
    });
};
var _default = EditFormTimeline;
